module.exports = __webpack_public_path__ + "61bfbd512608c1dec3b92360c8f73659.svg";